// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2f-3";
export var dialog = "_2f-0";
export var divClassnameSwatch = "_2f-8";
export var flexSwatch = "_2f-4";
export var header = "_2f-1";
export var styleAttributeSwatch = "_2f-7";
export var swatch = "_2f-2";
export var textHeaderSwatch = "_2f-5";
export var webSwatch = "_2f-6";